<template>
  <div class="w-full">
    
    <div class="call_section py-4 hero">
      <div class="wrapper">
        <h1 class="call text-3xl font-bold inline-block border-b pb-3 mb-4">{{call.title}}</h1>
        <p class="font-bold text-lg">{{call.event.start | formatDate}} at {{call.event.start | formatTime}}</p>
                <p class="mt-2">{{call.json.info}}</p>

      </div>
    </div>


    <div class="call_section mt-4 py-4 md:pb-0">
      <div class="wrapper">
        <h1 class="text-3xl font-bold inline-block border-b pb-3 mb-0">Join this call</h1>
      </div>
    </div>

    <div class="w-full md:w-3/4 mx-auto block relative">
      <div class="bar"></div>
              <iframe allow="microphone; camera; autoplay" src="https://edgeryders.daily.co/community" style=" width: 98%; margin: 0 auto; border: none; min-height: 600px;"></iframe>

    </div>

     <div class="call_section pt-4">
      <div class="wrapper">
        <h1 class="text-3xl font-bold inline-block border-b pb-3 mb-4">Participants</h1>
        <div class="flex justify-between">
          <div class="bg-gray-100 rounded-lg w-1/6 block mb-10" style="height: 120px"></div>
          <div class="bg-gray-100 rounded-lg w-1/6 block mb-10" style="height: 120px"></div>
          <div class="bg-gray-100 rounded-lg w-1/6 block mb-10" style="height: 120px"></div>
          <div class="bg-gray-100 rounded-lg w-1/6 block mb-10" style="height: 120px"></div>
          <div class="bg-gray-100 rounded-lg w-1/6 block mb-10" style="height: 120px"></div>
        </div>
      </div>
    </div>




     <div class="call_section pt-0 ">
      <div class="wrapper">
        <h1 class="text-3xl font-bold inline-block border-b pb-3 mb-4">Call Notes</h1>
        <div class="bg-gray-100 w-full block mb-10" style="height: 250px"></div>
      </div>
    </div>


  </div>
</template>

<script>

import moment from "moment";

export default {
  name: "home",
  data() {
    return {
    };
  },
  props: ["call"],
  components: {
  },
   filters: {
    formatTime: function(value) {
      return moment(value).format("HH:mm");
    },
    formatDate: function(value) {
      return moment(value).format("dddd, MMMM Do");
    }
  },
  computed: {
  }
};
</script>
<style lang="scss">
.call_section {
  @apply flex justify-center;
}
.call_section.hero {
  @apply bg-gray-100 items-center py-10;
}
.call_section .wrapper {
  @apply flex flex-col;
  max-width: 750px;
  min-width: 750px;
}
h1.call {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125'%3E%3Cswitch%3E%3Cg%3E%3Cpath fill='rgba(0,0,0,0.9)' d='M50 2.5a47.5 47.5 0 100 95 47.5 47.5 0 000-95zm26.1 65.1c-.9 2.2-2.5 4.4-3.5 5.4-5.7 5.7-21 .6-33.6-12-12.6-12.6-17.7-27.8-12-33.6 1-1 3.3-2.6 5.4-3.5 1.6-.7 3.5-.2 4.6 1.2l6.3 8a4 4 0 01-.5 5.4 94 94 0 00-3 2.7c-2.4 2.4 1.1 7.5 6.4 12.8 5.3 5.3 10.3 8.9 12.8 6.4a94 94 0 002.7-3 4 4 0 015.4-.5l8 6.3c1.3.8 1.7 2.7 1 4.4z'/%3E%3C/g%3E%3C/switch%3E%3C/svg%3E") no-repeat 0 50%;
  background-size: 35px;
  padding-left: 45px;
}

.bar {
  width: 100%;
  height: 30px;
  background: white;
  z-index: 9999;
  position: absolute;
  top: 0px;
}
</style>